import React, { useEffect } from 'react'
import './Services.css'
import { useDispatch, useSelector } from 'react-redux'
import { getServices } from '../../../actions/services.action';

import { Link } from 'react-router-dom'

import { Translate } from '../../Translate/Translate'
import i18next from 'i18next';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import Preloader from '../../Preloader';
import { API_URI } from '../../../axios';
import PageHeader from '../../page-header/PageHeader';
import { ChevronRight } from '@mui/icons-material';


const Services = () => {

    const dispatch = useDispatch()
    const language = i18next.language

    useEffect(() => {
        dispatch(getServices(language))
    }, [language])

    const services_s = useSelector(state => state.services)

    const { services } = services_s

    const { results } = services
    const {t} = useTranslation()


    // const handle_delete = (text) => {
    //     if (text.length > 250) {
    //         return text.substring(0, 250) + "..."
    //     } else {
    //         return text
    //     }
    // }

    // const handle_delete_title = (text) => {
    //     if (text.length > 25) {
    //         return text.substring(0, 25) + "..."
    //     } else {
    //         return text.substring(0, 25)
    //     }
    // }

    return (
        <>
        {

        }
            <Helmet>
                <title>{`${t("services")} - ${t("Ashgabat_International_Airport")}`}</title>
            </Helmet>
            <section className="Business services-page">
                <PageHeader
                    title={t("services")}
                    breadCrumbItems={[
                        { label: t("home"), path: '/' },
                        { label: t("services"), path: '#' }
                    ]}
                />
                <div className="container pt-12 pb-12">
                    {/* <div className="section-title text-center">
                        <h1 className='fw-bold'> <Translate title='services' /> </h1>
                    </div> */}
                    <div className="row">
                        {results ? results.map(item => (
                            <div key={item.id} className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="100ms">
                            <div className="services-one__single">
                                <div className="services-one__img">
                                    <img src={`${API_URI}${item.image}`} alt="" />
                                </div>
                                <div className=" services-one__content">
                                    <div className="services-one__title-box">
                                        <h4 className="services-one__title"><Link to={`/services/${item.id}`} style={{ textDecoration: 'none' }}>{item.title}</Link>
                                        </h4>
                                    </div>
                                    <p className="services-one__text" dangerouslySetInnerHTML={{ __html: item.description }} ></p>
                                    <div className="services-one__arrow">
                                        <Link to={`/services/${item.id}`} style={{ textDecoration: 'none' }}><ChevronRight /></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        ))
                            : <Preloader/>
                        }
                    </div>
                </div>
            </section>
        </>
    )
}

export default Services